import React, { useState } from "react";
import { useEffect } from "react";
import LoginModal from "./LoginModal";
import SignupModal from "./SignUpModak";
import "../styles/GameSelection.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import axios from "axios";  // Add this import
import	 { io } from "socket.io-client"; // Add this import 

// import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import { HiOutlineChevronLeft, HiOutlineChevronRight } from "react-icons/hi";


const games = [

    { id: 1, name: "Tic Tac Toe", image: "/assets/tikTakTok.webp" },
    { id: 2, name: "Snake", image: "/assets/Snake.jpg", disabled: false },
    { id: 3, name: "Chess", image: "/assets/Chess.jpg" },
    { id: 4, name: "Pong", image: "/assets/Pong.jpg" },
    { id: 5, name: "Stacks", image: "/assets/stack.jpg", disabled: false },

];

const GameSelection = () => {
    const [selectedGame, setSelectedGame] = useState(null);
    const [showLoginModal, setShowLoginModal] = useState(false);
    const [showSignupModal, setShowSignupModal] = useState(false);
    const [startIndex, setStartIndex] = useState(0);
    const [isMobile, setIsMobile] = useState(false);

    const token = localStorage.getItem("token");
    const isAuthenticated = token && token !== "null" && token !== "undefined";

    //const isAuthenticated = localStorage.getItem("token");
    const gamesPerPage = 3;
    const scrollStep = 2;

    // const handleSelectGame = async (game) => {
    //     if (!isAuthenticated) {
    //         setShowLoginModal(true);
    //         return;
    //     }
    
    //     try {
    //         const response = await axios.get(`http://localhost:5170/api/games/launch/${game.id}`, {


    //             headers: { 
    //                 Authorization: `Bearer ${localStorage.getItem("token")}` 
    //             }
    //         });
            
    //         console.log("Launch response:", response.data); // Debug log
            
            
    //         // Test if game server is reachable
    //         try {
    //             const launchResponse = await axios.get(`/api/games/launch/${gameId}`);
    
    //             console.log("Launch response:", launchResponse.data);
            
    //             // ✅ Extract gameUrl correctly from response
    //             const { gameUrl } = launchResponse.data;
            
    //             // ✅ Redirect to the game
    //             window.location.href = gameUrl;

    //         } catch (pingError) {
    //             alert(`Game server is running but not responding. Try refreshing.`);
    //             console.error("Game server ping failed:", pingError);
    //         }
            
    //     } catch (error) {
    //         console.error("Game launch error:", error.response?.data || error.message);
            
    //         if (error.response?.status === 400) {
    //             alert("You need more lives! Watch an ad to get more.");
    //         } 
    //         else if (error.response?.status === 503) {
    //             alert(`Game server is offline. Please try another game.`);
    //         }
    //         else {
    //             alert(`Error: ${error.response?.data?.Error || "Try again later"}`);
    //         }
    //     }
    // };

    const handleSelectGame = async (game) => {
    setSelectedGame(game);

    try {

        const response = await axios.get(
           `https://thelevelplay.com/api/games/launch/${game.id}`,
           {
                headers: {
                Authorization: `Bearer ${token}`
                }
            }
        );

        console.log("Full response:", response);
        console.log("Game URL from server:", response.data.gameUrl);

        if (!response.data.gameUrl) {
            throw new Error("No game URL found in response");
        }

       const newTab = window.open(response.data.gameUrl, '_blank');
 
   } catch (error) {
        console.error("Game launch failed:", error);
        alert(`Failed to launch game: ${error.message}`);
        }
  };


    const handleNext = () => {
        const nextIndex = startIndex + scrollStep;
        if (nextIndex + gamesPerPage <= games.length) {
            setStartIndex(nextIndex);
        }
    };

    const handlePrev = () => {
        const prevIndex = startIndex - scrollStep;
        if (prevIndex >= 0) {
            setStartIndex(prevIndex);
        }
    };

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };
    
        handleResize(); // Run on mount
        window.addEventListener("resize", handleResize);
    
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    // const visibleGames = games.slice(startIndex, startIndex + gamesPerPage);

    const visibleGames = isMobile
    ? games
    : games.slice(startIndex, startIndex + gamesPerPage);


    return (
        <div className="game-selection-container">
            <div className="container py-4 d-flex justify-content-center align-items-center">
                
                <div className="row align-items-center">
                    {/* Left Arrow */}
                    { !isMobile && startIndex > 0 && (
                        <div className="col-auto">
                            <button className="pagination-dnone ml-4" onClick={handlePrev}>
                                <HiOutlineChevronLeft size={30}/>
                            </button>
                            {/* <button className="pagination-dnone ml-4" onClick={handlePrev}>
                                <i className="bi bi-chevron-left fs-2"></i>
                            </button> */}

                        </div>
                    )}

                    {/* Game Cards */}

                    {visibleGames.map((game) => (
                       <div className="col-md-3 col-sm-4 col-10 mb-4" key={`${game.name}-${game.id}`}>
                       <div
                           className={`game-card text-center ${game.disabled ? "disabled-card" : ""}`}
                           onClick={() => {
                             if (!game.disabled) handleSelectGame(game);
                           }}
                           style={{ cursor: game.disabled ? "not-allowed" : "pointer", opacity: game.disabled ? 0.5 : 1 }}
                       >
                           <img src={game.image} alt={game.name} className="game-image img-fluid" />
                           <h1 className="game-name mt-2">{game.name}</h1>
                       </div>
                      </div>
                     ))}
                    
                
                    {/* Right Arrow */}
                    {!isMobile && startIndex + gamesPerPage < games.length && (
                        <div className="col-auto">
                            <button className="pagination-dnone" onClick={handleNext}>
                                {/* &gt; */}
                                <HiOutlineChevronRight size={30}/>
                            </button>
                            {/* <button className="pagination-dnone" onClick={handleNext}>
                                <i className="bi bi-chevron-right fs-2"></i>
                            </button> */}
                        </div>
                    )}



                </div>
            </div>
            {/* Modals */}
            {showLoginModal && (
                <LoginModal
                    onClose={() => setShowLoginModal(false)}
                    onShowSignup={() => {
                        setShowLoginModal(false);
                        setShowSignupModal(true);
                    }}
                    onLoginSuccess={() => {
                        const gameId = selectedGame.id;
                        // window.location.href = '/game-session/${selectedGame.name}/${gameId}';
                    }}
                />
            )}

            {showSignupModal && (
                <SignupModal
                    onClose={() => setShowSignupModal(false)}
                    onSignupSuccess={() => {
                        setShowSignupModal(false);
                        setShowLoginModal(true);
                    }}
                />
            )}
        </div>
    );
};

export default GameSelection;

